import React, { useState, useContext } from 'react'
import { MyContext } from '../..'
import Heading from '../../GitHubComponents/Heading'
import {Input} from '../../GitHubComponents/Inputs'
import Button from '../../GitHubComponents/Button'
import Alert from '@mui/material/Alert';
import { createSubscriber } from "../../services"

export default function NewOrganizations(props) {
    document.title = props.title
    const queryParameters = new URLSearchParams(window.location.search)
    const username = queryParameters.get("username") || props.userData.username
    const organisationCode = queryParameters.get("orgcode") || props.orgCode
    const { backendUrl } = useContext(MyContext);

    const [formData, setFormData] = useState({
        // Initialize the form fields with default values or leave them empty
        organizationCode: organisationCode,
        userUsername: username,
        name: "",
        email: "",
        number: "",
        address: "",
        website: "",
        description: ""
    });
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can handle form submission logic here
        const response = await createSubscriber(backendUrl, formData);
        if (response.code === 201) {
            console.log("School created successfully");
            setAlert({
                type: "success",
                message: response.message,
                show: true,
            });
        } else {
            setAlert({
                type: "error",
                message: response.message,
                show: true,
            });
        }
    };
    return (
        <div>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => {setAlert({show: false})}} style={{margin: "10px auto"}}>{alert.message}</Alert>}
            <Heading heading="Set up your organization" />
            <form onSubmit={handleSubmit}>
                <Input type={"text"} id={"organizationName"} name={"name"} lable={"Organization name"} value={formData.name} onChange={handleChange} minLength={5} pattern={"[^#]*"} title={"Input should not contain # character."} required="true" />
                <Input type={"email"} id={"organizationEmail"} name={"email"} lable={"Contact Email"} value={formData.email} onChange={handleChange} minLength={5} required="true" />
                <Input type={"number"} id={"organizationNumber"} name={"number"} lable={"Phone Number"} value={formData.phoneNumber} onChange={handleChange} minLength={5} required="true" />
                <Input type={"text"} id={"organizationAddress"} name={"address"} lable={"Address"} value={formData.address} onChange={handleChange} minLength={5} required="true" />
                <Input type={"url"} id={"organizationWebsite"} name={"website"} lable={"Website url"} value={formData.website} onChange={handleChange} minLength={5} required="true" />
                <Input type={"text"} id={"organizationDescription"} name={"description"} lable={"Description"} value={formData.description} onChange={handleChange} minLength={5} required="true" />
                <Button text={"Create"} type={"submit"} style={{color: "white", width: "440px", backgroundColor: "#1f883d"}}/>
            </form>
        </div>
    )
}
